
import { isTomorrowInParis } from '@/utils/localDate'

export default {
  name: 'DeliveredFromDate',
  props: {
    date: {
      type: String,
      default: null,
    },
    format: {
      type: String,
      default: 'EEEE d MMMM',
    },
    dateClass: {
      type: [String, Array, Object],
      default: null,
    },
  },
  computed: {
    tomorrow() {
      return isTomorrowInParis(this.date)
    },
  },
}
